import React, { useEffect } from "react";
import { useState } from "react";
import usePersistentDateRange from "../../Common/usePersistentDateRange";
import categorySelectionDynamic from "../../Common/categorySelectionDynamic";
import { getAddGroupApi, getCampaignApi, getSearchApi, getTargetApi, getProductApi,getCustomerSearchApi } from "../../../../services/campaign";

const useSearchKeyword = () => {

  const [level, setLevel] = useState("campaign");
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedAdGroup, setSelectedAdGroup] = useState(null);
  const [selectedTarget, setSelectedTarget] = useState(null);
  const [search, setSearch] = useState("");
  const [campaignSate, setcampaignState] = useState([]);
  const [campaignSateSequence, setcampaignSateSequence] = useState([]);
  const [selectedIds, setSelectedIds] = useState({
    productId: [],
    categoryId: [],
    parentProductId: [],
  });
  const [selectedCampaignIds, setSelectedCampaignIds] = useState({ categoryId: [], productId: [] });
  const [selectedAdGroupIds, setSelectedAdGroupIds] = useState({ categoryId: [], productId: [] });
  const [selectedProductIds, setSelectedProductIds] = useState({ categoryId: [], productId: [] });
  const [selectedTargetIds, setSelectedTargetIds] = useState({ categoryId: [], productId: [] });
  const [selectedSearchIds, setSelectedSearchIds] = useState({ categoryId: [], productId: [] });
  const [selectedCustomerSearchIds, setSelectedCustomerSearchIds] = useState({ categoryId: [], productId: [] });
  const [campaignData, setCampaignData] = useState([]);
  const [addGroupData, setAddGroupData] = useState([]);
  const [targetData, setTargetData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [customerSearchData, setCustomerSearchData] = useState([]);
  const [productData, setProductData] = useState([]);
  const campaignSequence = {
    columns: [
      "campaign_name",
      "status",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion"
    ]
  };

  // const [addGroupSequence, setAddGroupSequence] = useState([]);
  const addGroupSequence = {
    columns: [
      "adgroup_name",
      "status",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion"
    ]
  };
  const targetSequence = {
    columns: [
      "targeting",
      "ad_group",
      "campaign",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion",
      "match_type"
    ]
  };
  const searchSequence = {
    columns: [
      "term",
      "word",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion",
      "match_type"
    ]
  };
  const customerSearchSequence = {
    columns: [
      "term",
      "ad_group",
      "campaign",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion",
      "match_type"
    ]
  };
  const productSequence = {
    columns: [
      "product_name",
      "asin",
      "sku",
      "brand",
      "ad_group",
      "campaign",
      "status",
      "impressions",
      "clicks",
      "ctr",
      "spend",
      "cpc",
      "ads_sales",
      "ads_units",
      "avg_order_value",
      "acos",
      "roas",
      "ads_conversion",
      "match_type"
    ]
  };
  // const [searchSequence, setSearchSequence] = useState([]);
  // const [productSequence, setProductSequence] = useState([]);
  const [loading, setLoading] = useState({
    campaign: true,
    adgroup: true,
    target: true,
    search: true,
    product: true,
    customerSearch:true
  });
  const { selectedRange, handleDateChange, formattedStart, formattedEnd } = usePersistentDateRange();
  const { categoryId, categoryName, setCategoryId, setCategoryName, onBreadcrumbClick, handleCategoryClick, handleParentProductClick, } = categorySelectionDynamic(formattedStart, formattedEnd);

  const [filterValue, setFilterValue] = useState({
    formattedStart,
    formattedEnd,
    campaign_id: null,
    targeting: null,
    adgroup_id: null,
    search_term: null,
    product: null,
    customer_search_term:null
  })


  const fetchAllTables = async (formattedStart = filterValue?.formattedStart, formattedEnd = filterValue?.formattedEnd, campaign_id = filterValue?.campaign_id, targeting = filterValue?.targeting, adgroup_id = filterValue?.adgroup_id, search_term = filterValue?.search_term, products = filterValue?.product,filter,customer_search_term=filterValue?.customer_search_term) => {
    if (!formattedStart && !formattedEnd)
      return
    try {
      setLoading({
        campaign: true,
        adgroup: true,
        target: true,
        search: true,
        product: true,
        customerSearch:true
      });

      const [campaignRes, addGroupRes, targetRes, searchRes, productRes,customerRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
          getAddGroupApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
          getTargetApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
          getSearchApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
          getProductApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
          getCustomerSearchApi({ formattedStart, formattedEnd, campaign_id, adgroup_id, targeting, search_term, products,customer_search_term,filter }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setSearchData(searchRes?.value?.data || []);
      // setSearchSequence(searchRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      setCustomerSearchData(customerRes?.value?.data || []);
      // setProductSequence(productRes?.value?.sequence || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        adgroup: false,
        target: false,
        search: false,
        product: false,
        customerSearch:false
      });
    }
  };


  const handleCampaignClick = async (row, meta) => {
    if (meta?.isBulk) return;
    setSelectedCampaignIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      campaign_id: row.categoryId,
      targeting: null,
      adgroup_id: null,
      search_term: null,
      product: null,
      customer_search_term:null
    }))

    try {
      setLoading({
        adgroup: true,
        target: true,
        search: true,
        product: true,
        customerSearch:true
      });
      const [addGroupRes, targetRes, searchRes, productRes,customerRes] =
        await Promise.allSettled([
          getAddGroupApi({ formattedStart, formattedEnd, campaign_id: row.categoryId }),
          getTargetApi({ formattedStart, formattedEnd, campaign_id: row.categoryId }),
          getSearchApi({ formattedStart, formattedEnd, campaign_id: row.categoryId }),
          getProductApi({ formattedStart, formattedEnd, campaign_id: row.categoryId }),
          getCustomerSearchApi({ formattedStart, formattedEnd, campaign_id: row.categoryId }),
        ]);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setSearchData(searchRes?.value?.data || []);
      // setSearchSequence(searchRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      // setProductSequence(productRes?.value?.sequence || []);
      setCustomerSearchData(customerRes?.value?.data || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        adgroup: false,
        target: false,
        search: false,
        product: false,
        customerSearch:false
      });
    }
  };

  const handleAdGroupClick = async (row, meta) => {
    if (meta?.isBulk) return;
    setSelectedAdGroupIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      adgroup_id: row.categoryId,
      campaign_id: null,
      targeting: null,
      search_term: null,
      product: null,
      customer_search_term:null
    }))
    try {
      setLoading({
        campaign: true,
        target: true,
        search: true,
        product: true,
        customerSearch:true
      });
      const [campaignRes, targetRes, searchRes, productRes,customerRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, adgroup_id: row.categoryId }),
          getTargetApi({ formattedStart, formattedEnd, adgroup_id: row.categoryId }),
          getSearchApi({ formattedStart, formattedEnd, adgroup_id: row.categoryId }),
          getProductApi({ formattedStart, formattedEnd, adgroup_id: row.categoryId }),
          getCustomerSearchApi({ formattedStart, formattedEnd, adgroup_id: row.categoryId }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setSearchData(searchRes?.value?.data || []);
      // setSearchSequence(searchRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      // setProductSequence(productRes?.value?.sequence || []);
      setCustomerSearchData(customerRes?.value?.data || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        target: false,
        search: false,
        product: false,
        customerSearch:false
      });
    }
  };

  const handleTargetClick = async (row, meta) => {
    if (meta?.isBulk) return;
    setSelectedTargetIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      targeting: row.categoryId,
      adgroup_id: null,
      campaign_id: null,
      search_term: null,
      product: null,
      customer_search_term:null
    }))
    try {
      setLoading({
        campaign: true,
        adgroup: true,
        search: true,
        product: true,
        customerSearch:true
      });
      const [campaignRes, addGroupRes, searchRes, productRes,customerRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, targeting: row.categoryId }),
          getAddGroupApi({ formattedStart, formattedEnd, targeting: row.categoryId }),
          getSearchApi({ formattedStart, formattedEnd, targeting: row.categoryId }),
          getProductApi({ formattedStart, formattedEnd, targeting: row.categoryId }),
          getCustomerSearchApi({ formattedStart, formattedEnd, targeting: row.categoryId }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setSearchData(searchRes?.value?.data || []);
      // setSearchSequence(searchRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      setCustomerSearchData(customerRes?.value.data || []);
      // setProductSequence(productRes?.value?.sequence || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        adgroup: false,
        search: false,
        product: false,
        customerSearch:false
      });
    }
  };

  const handleSearchClick = async (row, meta) => {
    if (meta?.isBulk) return;
    setSelectedSearchIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      search_term: row.categoryId,
      targeting: null,
      adgroup_id: null,
      campaign_id: null,
      product: null,
      customer_search_term:null,
    }))
    try {
      setLoading({
        campaign: true,
        adgroup: true,
        target: true,
        product: true,
        customerSearch:true
      });
      const [campaignRes, addGroupRes, targetRes, productRes,customerRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, search_term: row.categoryId }),
          getAddGroupApi({ formattedStart, formattedEnd, search_term: row.categoryId }),
          getTargetApi({ formattedStart, formattedEnd, search_term: row.categoryId }),
          getProductApi({ formattedStart, formattedEnd, search_term: row.categoryId }),
          getCustomerSearchApi({ formattedStart, formattedEnd, search_term: row.categoryId }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      setCustomerSearchData(customerRes?.value?.data || []);
      // setProductSequence(productRes?.value?.sequence || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        adgroup: false,
        target: false,
        product: false,
        customerSearch:false
      });
    }
  };

  const handleCustomerSearchClick = async (row, meta) => {
    if (meta?.isBulk) return;
    setSelectedCustomerSearchIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      customer_search_term: row.categoryId,
      targeting: null,
      adgroup_id: null,
      campaign_id: null,
      product: null,
      search_term:null
    }))
    try {
      setLoading({
        campaign: true,
        adgroup: true,
        target: true,
        product: true,
        search:true
      });
      const [campaignRes, addGroupRes, targetRes, productRes,searchRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, customer_search_term: row.categoryId   }),
          getAddGroupApi({ formattedStart, formattedEnd, customer_search_term: row.categoryId   }),
          getTargetApi({ formattedStart, formattedEnd, customer_search_term: row.categoryId   }),
          getProductApi({ formattedStart, formattedEnd, customer_search_term: row.categoryId  }),
          getSearchApi({ formattedStart, formattedEnd, customer_search_term: row.categoryId   }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setProductData(productRes?.value?.data || []);
      setSearchData(searchRes?.value?.data || []);
      // setProductSequence(productRes?.value?.sequence || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        adgroup: false,
        target: false,
        product: false,
        search:false
      });
    }
  };
  
  const handleProductClick = async (row, meta) => {
      
    if (meta?.isBulk) return;
    setSelectedProductIds({
      productId: [],
      categoryId: row.categoryId, // This checks the boxes in the UI
    });
    setFilterValue((prev) => ({
      ...prev,
      product: row.categoryId,
      search_term: null,
      targeting: null,
      adgroup_id: null,
      campaign_id: null,
      customer_search_term:null
    }))
    try {
      setLoading({
        campaign: true,
        adgroup: true,
        target: true,
        search: true,
        customerSearch:true
      });
      const [campaignRes, addGroupRes, targetRes, searchRes,customerRes] =
        await Promise.allSettled([
          getCampaignApi({ formattedStart, formattedEnd, products: row.categoryId }),
          getAddGroupApi({ formattedStart, formattedEnd, products: row.categoryId }),
          getTargetApi({ formattedStart, formattedEnd, products: row.categoryId }),
          getSearchApi({ formattedStart, formattedEnd, products: row.categoryId }),
          getCustomerSearchApi({ formattedStart, formattedEnd, products: row.categoryId }),
        ]);
      setCampaignData(campaignRes?.value?.data || []);
      // setCampaignSequence(campaignRes?.value?.sequence || []);
      setAddGroupData(addGroupRes?.value?.data || []);
      // setAddGroupSequence(addGroupRes?.value?.sequence || []);
      setTargetData(targetRes?.value?.data || []);
      // setTargetSequence(targetRes?.value?.sequence || []);
      setSearchData(searchRes?.value?.data || []);
      // setSearchSequence(searchRes?.value?.sequence || []);
      setCustomerSearchData(customerRes?.value?.data || []);

    } catch (error) {
      console.error("Error loading tables:", error);
    } finally {
      setLoading({
        campaign: false,
        adgroup: false,
        target: false,
        search: false,
        customerSearch:false
      });
    }
  };

  const handleBreadcrumbNavigation = (index, breadcrumb) => {

    // Home / Campaign root
    if (index === 0) {
      setLevel("campaign");
      setSelectedCampaign(null);
      setSelectedAdGroup(null);
      setSelectedTarget(null);
      return;
    }

    // Campaign level
    if (index === 1) {
      setLevel("adgroup");
      setSelectedAdGroup(null);
      setSelectedTarget(null);
      return;
    }

    // AdGroup level
    if (index === 2) {
      setLevel("target");
      setSelectedTarget(null);
      return;
    }

    // Target level
    if (index === 3) {
      setLevel("searchterm");
    }
  };
  const goBack = () => {
    if (level === "searchterm") setLevel("target");
    else if (level === "target") setLevel("adgroup");
    else if (level === "adgroup") setLevel("campaign");
  };

  const getCampaignData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: true,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
    const response = await getCampaignApi({ formattedStart, formattedEnd});
    setCampaignData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }
  const getAdGroupData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: false,
      adgroup: true,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
    const response = await getAddGroupApi({ formattedStart, formattedEnd});
    setAddGroupData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }
  const getTargetingData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: false,
      adgroup: false,
      target: true,
      search: false,
      product: false,
      customerSearch:false
    });
    const response = await getTargetApi({ formattedStart, formattedEnd});
    setTargetData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }
  const getSearchTermData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: true,
      product: false,
      customerSearch:false
    });
    const response = await getSearchApi({ formattedStart, formattedEnd});
    setSearchData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }
  const getCustomerSearchData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:true
    });
    const response = await getCustomerSearchApi({ formattedStart, formattedEnd});
    setCustomerSearchData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }
  const getProductData = async (formattedStart,formattedEnd) =>{
  try{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: true,
      customerSearch:false
    });
    const response = await getProductApi({ formattedStart, formattedEnd});
    setProductData(response?.data || []);

  }catch(error){
    console.log(error)
  }finally{
    setLoading({
      campaign: false,
      adgroup: false,
      target: false,
      search: false,
      product: false,
      customerSearch:false
    });
  }
  }

  const handleSelectionChange = (ids) => {
    const selectedCampaignIds = (ids.categoryId || []).map(String);
    const filteredAdGroup = addGroupData.filter(ad =>
      selectedCampaignIds.includes(ad.campaign_id?.toString())
    );

    setAddGroupData(filteredAdGroup);

    //  Extract adgroup_ids
    const adGroupIds = filteredAdGroup.map(ad =>
      ad.adgroup_id?.toString()
    );

    //  Filter Targeting using adgroup_id
    const filteredTargets = targetingData.filter(target =>
      adGroupIds.includes(target.adgroup_id?.toString())
    );

    setTargetData(filteredTargets);

    //  Extract targeting values (depends on your API)
    const targetingValues = filteredTargets.map(t =>
      t.targeting || t.keyword || t.target_id
    );

    //  Filter Search Terms
    const filteredSearch = searchData.filter(search =>
      targetingValues.includes(search.targeting || search.keyword)
    );

    setSearchData(filteredSearch);
  };

  return {
    level,
    setLevel,
    search,
    setSearch,
    selectedCampaign,
    selectedAdGroup,
    selectedTarget,
    handleCampaignClick,
    handleAdGroupClick,
    handleTargetClick,
    goBack,
    selectedRange,
    handleDateChange,
    formattedEnd,
    formattedStart,
    categoryId,
    categoryName,
    onBreadcrumbClick,
    handleBreadcrumbNavigation,
    handleCategoryClick,
    handleParentProductClick,
    campaignData,
    addGroupData,
    campaignSate,
    selectedIds,
    targetData,
    searchData,
    productData,
    setSelectedIds,
    campaignSateSequence,
    fetchAllTables,
    handleSelectionChange,
    campaignSequence,
    addGroupSequence,
    targetSequence,
    searchSequence,
    productSequence,
    setFilterValue,
    loading,
    handleSearchClick,
    handleProductClick,
    filterValue,
    selectedCampaignIds,
    setSelectedCampaignIds,
    selectedAdGroupIds,
    setSelectedAdGroupIds,
    selectedProductIds,
    setSelectedProductIds,
    selectedTargetIds,
    setSelectedTargetIds,
    selectedSearchIds,
    setSelectedSearchIds,
    selectedCustomerSearchIds,
    setSelectedCustomerSearchIds,
    handleCustomerSearchClick,
    customerSearchSequence,
    customerSearchData,
    getCampaignData,
    getAdGroupData,
    getTargetingData,
    getSearchTermData,
    getCustomerSearchData,
    getProductData

  };
};

export default useSearchKeyword;